define(function(require) {
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const buildUrl = require('civicsUtils/buildUrlParameters.js');
	const AvailableFeatures = require('civicsUtils/available_features');
	return IpsModelCollection.extend({
		urlRoot:'/delegate/civics-api/api/',
		instrumentUrls: {
			building: 'cdr/applicationtypes/Building/',
			businesslicense: 'cdr/applicationtypes/BusinessLicense/',
			planning: 'cdr/applicationtypes/Planning/',
			project: 'cdr/applicationtypes/Project/',
			tradelicense: 'cdr/applicationtypes/TradeLicense/',
			use: 'cdr/applicationtypes/Use/',
			servicerequest: 'crm/setup/servicerequesttypes/',
			servicerequestbilling: 'crm/setup/account/servicerequesttypes/',
		},
		url: function() {
			var ret = '';
			if (this.instrumentType){
				ret =  this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()];//+buildUrl.buildUrlParameters(options);

				if (this.urlParameters) {
					ret += buildUrl.buildUrlParameters(this.urlParameters)
				}

				var instrumentTypeLower = this.instrumentType.toLowerCase();
				if (instrumentTypeLower === 'servicerequest' || instrumentTypeLower === 'servicerequestbilling') {
					if (ret.indexOf('?') >= 0) {
						ret += '&lightweightextensions=true&Page=[{Max:0}]';
					} else {
						ret += '?lightweightextensions=true&Page=[{Max:0}]';
					}
				} else {
					if (ret.indexOf('?') >= 0) {
						ret += '&Page=[{Max:0}]';
					} else {
						ret += '?Page=[{Max:0}]';
					}
				}
			}
			return ret;
		},
		parse:function(response){
			var ret = response.data;
			if(this.instrumentType.toLowerCase() == 'servicerequest'){
				for(var i = 0;i<ret.length;i++){
					ret[i].code = ret[i].type;
					ret[i].type = 'servicerequest';

					//check if there is no description or portal description
					if( (ret[i].description == null || ret[i].description.trim().length <= 0) && (ret[i].portalDescription == null || ret[i].portalDescription.trim().length <= 0 )){
						ret[i].portalDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
					}
					//if we have the extra flag in place to allow for public vs customer submit rules, add the customer flag.
					//this way we don't need to check throughout the add instrument portlet.
					if(AvailableFeatures.ServiceRequestPublicVsCustomerSubmit() && ret[i].submitInPortal!=null){
						ret[i].submitInPortalCustomer = ret[i].submitInPortal;
					}
				}
				
			}
			else if(this.instrumentType.toLowerCase() == 'servicerequestbilling'){
				for(var i = 0;i<ret.length;i++){
					ret[i].code = ret[i].type;
					ret[i].type = 'servicerequest';

					//check if there is no description or portal description
					if( (ret[i].description == null || ret[i].description.trim().length <= 0) && (ret[i].portalDescription == null || ret[i].portalDescription.trim().length <= 0 )){
						ret[i].portalDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
					}
				}				
			}

			return ret;
		}
	});
});
